const verification_record = {
    not_found: '未能找到驗證記錄。',
    permission_denied: '沒有權限，請重新驗證。',
    not_supported_for_google_one_tap: '此 API 不支持 Google One Tap。',
};
export default Object.freeze(verification_record);
